import type { ApiInvoiceSnapshot } from '@Model';
import { useSyncExternalStore } from 'react';

/** The rows the list has loaded, in list order, and how many its search holds in total. */
export interface PreviewRows {
    rows: ApiInvoiceSnapshot[];
    total: number;
    /** Loads the next page of the list. */
    fetchNextPage?: () => void;
}

/** The loaded rows of the list, for a panel that lives outside the list and has to follow it. */
export interface PreviewRowsSource {
    get: () => PreviewRows;
    set: (next: PreviewRows) => void;
    subscribe: (listener: () => void) => () => void;
}

/** A store of the loaded rows that the list writes and the preview reads. */
// @ai-generated 2026-10-05T13:53:41+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function createPreviewRowsSource(initial: PreviewRows = { rows: [], total: 0 }): PreviewRowsSource {
    let current = initial;
    const listeners = new Set<() => void>();

    return {
        get: () => current,
        set: (next) => {
            current = next;
            listeners.forEach((listener) => listener());
        },
        subscribe: (listener) => {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
    };
}

/** The current rows of `source`, re-rendering whenever the list loads more. */
// @ai-generated 2026-10-05T13:53:41+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function usePreviewRows(source: PreviewRowsSource): PreviewRows {
    return useSyncExternalStore(source.subscribe, source.get);
}
